<div class="container mt-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToManagePromotion()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Manage Promotion
            </span>
        </div>
    </div>
    <div class="card card_content">
        <div *ngIf="!ServiceProviderShow">
            <form [formGroup]="promotionForm">
                <div class="row">
                    <div class="col-sm-12 col-xl-4 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Promotion Name</mat-label>
                            <input matInput maxlength="100" type="text" id="promoName"
                                placeholder="Enter Promotion Name" formControlName="promoName" autocomplete="off"
                                specialIsAlphaNumeric class="col-12" (keydown.space)="preventLeadingSpace($event)">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-xl-4 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Promotion Code</mat-label>
                            <input matInput type="text" id="promoCode" (input)="convertToUpperCase($event)"
                                placeholder="Enter Promotion Code" formControlName="promoCode" autocomplete="off"
                                specialIsAlphaNumeric class="col-12" (keydown.space)="preventLeadingSpace($event)"
                                (input)="restrictSpecialChars($event)">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-4 mt-4 ml-3 px-0">
                        <ng-multiselect-dropdown formControlName="serviceProviderIds"
                            placeholder="Select Service Provider" [settings]="dropdownSettings"
                            [data]="serviceproviderlist" [disabled]="view == 2">
                        </ng-multiselect-dropdown>
                    </div>

                    <div class="col-sm-12 col-xl-4 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Promotion Start Date</mat-label>
                            <input readonly matInput appInputtext [matDatepicker]="startDatePicker"
                                formControlName="promoStartDate" autocomplete="off" [min]="today"
                                placeholder="Select From Date" class="custom-input-border"
                                (dateChange)="onStartDateChange($event)" (click)="startDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-xl-4 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Promotion End Date</mat-label>
                            <input readonly matInput appInputtext [matDatepicker]="endDatePicker"
                                formControlName="promoEndDate" autocomplete="off" [min]="minEndDate"
                                placeholder="Select End Date" class="custom-input-border"
                                (click)="endDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-xl-4 mt-4 form-radio-group mobile">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Promotion Duration (In Months)</mat-label>
                            <input matInput maxlength="100" type="text" id="duration"
                                placeholder="Enter Promotion Duration (In Months)" formControlName="promotionValidity"
                                autocomplete="off" specialIsAlphaNumeric class="col-12"
                                (keypress)="onlyNumbers($event)">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-xl-4 form-radio-group mobile mt-4 pl-4">
                        <mat-radio-group class="mat-radio-group tp-radio-button ng-untouched ng-pristine ng-invalid"
                            hideRequiredMarker>
                            <mat-label ngClass="form-text">Select Customer Type :</mat-label>
                            <!-- <mat-radio-button value="1">Reseller</mat-radio-button><br> -->
                            <mat-radio-button value="2" checked>Normal Customer</mat-radio-button><br>
                            <!-- <mat-radio-button value="3">Both</mat-radio-button> -->
                        </mat-radio-group>
                    </div>
                    <div class="col-sm-12 col-xl-4 form-radio-group mobile mt-4 pl-4">
                        <mat-radio-group class="mat-radio-group tp-radio-button ng-untouched ng-pristine ng-invalid"
                            hideRequiredMarker formControlName="promotionValidityType">
                            <mat-label ngClass="form-text">Applicable from :</mat-label>
                            <mat-radio-button value=1>Completed to be Build</mat-radio-button><br>
                            <mat-radio-button value=2>New Application</mat-radio-button><br>
                        </mat-radio-group>
                    </div>
                    <div class="col-sm-12 col-xl-4 form-radio-group mobile mt-4" style="padding-left: 35px !important;">
                        <mat-label class="form-text" style="margin-left: -18px !important; margin-bottom: 5px;">
                            Applicable for Service Types:
                        </mat-label>
                        <div class="row" formArrayName="applicableServiceType">
                            <div class="col-xl-6 mb-1 pl-0" *ngFor="let service of serviceTypes">
                                <mat-checkbox color="primary"
                                    [checked]="promotionForm.get('applicableServiceType').value.includes(service.id)"
                                    [value]="service.id.toString()" (change)="onCheckboxChange($event, service.id)"
                                    [disabled]="checkdisable">
                                    {{ service.name }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3 mt-4">
                    <div class="col-xl-12 text-right">
                        <button (click)="navigate()" class="btn btn-primary">Next</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>